import { authTokenStore } from '@weareopenr/authkit';

export const fetch = async (url: string, options?: RequestInit) => {
  const accessToken = await authTokenStore.getAccessToken();
  const requestOptions: RequestInit = {
    ...options,
    headers: {
      ...options?.headers,
      Authorization: `Bearer ${accessToken}`,
    },
  };
  return globalThis.fetch(url, requestOptions);
};
